<template>
  <footer class="nongmon-red-bg text-white font-thai">
    <div class="container max-w-screen-xl mx-auto px-4 py-8">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div class="flex flex-col items-center justify-center">
          <router-link to="/">
            <img
              src="@/assets/images/nongmon-logo-white.webp"
              class="h-20"
              alt="nongmon logo"
            />
          </router-link>
          <div class="flex gap-6">
            <a
              href="https://www.facebook.com/nongmon247"
              target="_blank"
              rel="noopener noreferrer"
              class="flex justify-center items-center border-2 border-white rounded-full w-10 h-10"
              ><i class="fab fa-facebook text-lg"></i
            ></a>
            <a
              href="https://www.instagram.com/nongmon247"
              target="_blank"
              rel="noopener noreferrer"
              class="flex justify-center items-center border-2 border-white rounded-full w-10 h-10"
              ><i class="fab fa-instagram text-lg"></i
            ></a>
            <a
              href="https://www.tiktok.com/@nongmonmarket"
              target="_blank"
              rel="noopener noreferrer"
              class="flex justify-center items-center border-2 border-white rounded-full w-10 h-10"
              ><i class="fab fa-tiktok text-lg"></i
            ></a>
          </div>
        </div>
        <div
          class="flex flex-col items-center md:items-start text-center md:text-left gap-4"
        >
          <h3 class="font-bold text-xl">Contact Us</h3>
          <div>
            <h3>Address</h3>
            <p class="text-sm">
              เทศบาลเมืองแสนสุข<br />ถ.บางแสนสาย 2<br />
              ต.แสนสุข อ.เมือง<br />จ.ชลบุรี 20130
            </p>
          </div>
          <div>
            <h3>Phone</h3>
            <a href="tel:+66909123456">038 193 500-2</a>
          </div>
          <div>
            <h3>Email</h3>
            <a href="mailto:nongmonfoodchallenge@gmail.com"
              >nongmonfoodchallenge@gmail.com</a
            >
          </div>
        </div>
        <div
          class="flex flex-col items-center text-center md:items-start md:text-left uppercase"
        >
          <ul class="space-y-2">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/about">About</router-link></li>
            <li><router-link to="/articles/news">Hot News</router-link></li>
            <li><router-link to="/shops">Must Eat</router-link></li>
            <li>
              <router-link to="/articles/articles#guide"
                >Food & Travel Guide</router-link
              >
            </li>
            <li>
              <a href="https://www.nongmon247.com/Nongmon-Food-Map.pdf"
                >Download Map</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex justify-center items-center bg-white w-full h-10">
      <p class="text-red-600">
        &copy; {{ currentYear }} Nongmon 247. All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script setup>
import { ref } from "vue";

const currentYear = ref(new Date().getFullYear());
</script>

<style scoped>
.nongmon-red-bg {
  background-color: #e91c3e;
}
</style>
